import { CustomerOverviewAction, CustomerOverviewActionTypes } from './types';
import { CustomerOverviewState, Profile } from '../../models/customerOverview';

export const customerOverviewInitialState: CustomerOverviewState = {
  loading: true,
  kitsData: {
    kits: [],
    total: 0,
  },
  profiles: {},
  kitStatusFilter: undefined,
  searchTerm: '',
  currentPage: 1,
  kitOverViewResponse: undefined,
};

const customerOverviewReducers = (state = customerOverviewInitialState, action: CustomerOverviewAction): CustomerOverviewState => {
  switch (action.type) {
    case CustomerOverviewActionTypes.CLEAR_SEARCH_PARAMETERS:
      return {
        ...state,
        kitStatusFilter: undefined,
        searchTerm: '',
      };
    case CustomerOverviewActionTypes.START_FETCHING_KITS:
      return {
        ...state,
        loading: true,
      };
    case CustomerOverviewActionTypes.FETCH_KITS_SUCCESS:
      return {
        ...state,
        loading: false,
        kitsData: {
          kits: action.payload.kits,
          total: Number(action.payload.total),
        },
      };
    case CustomerOverviewActionTypes.FETCH_PROFILES_SUCCESS:
      return {
        ...state,
        profiles: {
          ...state.profiles,
          ...action.payload.reduce<Record<string, Profile>>((acc, profile) => {
            acc[profile.profileId] = profile;
            return acc;
          }, {}),
        },
      };
    case CustomerOverviewActionTypes.FETCH_KITS_BY_STATUS:
      return {
        ...state,
        kitStatusFilter: action.payload,
      };
    case CustomerOverviewActionTypes.SET_TABLE_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case CustomerOverviewActionTypes.SET_TABLE_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload,
      };
    case CustomerOverviewActionTypes.SET_KIT_STATUS_OVERVIEW_SUCCESS:
      return {
        ...state,
        kitOverViewResponse: action.payload,
      };
  }

  return state;
};

export default customerOverviewReducers;
